module.exports = __webpack_public_path__ + "img/image-douglas-hurley.aa7df252.webp";